<div class="alarms-summary">
  <div *ngIf="selection?.length !== 1" class="arm-summary">{{selection?.length || 0}} Items selected</div>
  <div *ngIf="selection?.length === 1" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Severity:</span>
      <span><i class='fa fa-square label-{{selection[0].alarmSeverity | alarmSeverity}} severity-icon'></i></span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmSeverity | alarmSeverity}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Date & Time:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmDateAndTime | date : 'dd-MMM-yy H:mm:ss'}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].name}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Source:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmSource}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Alarm Type:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmType | alarmType}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Probable Cause:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmProbCause | alarmProbableCause}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Description:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmTextualDescription}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Additional Info 1:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmAddInfo1}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Additional Info 2:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmAddInfo2}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Additional Info 3:</span>
      <span class="arm-summary-value" fxFlex>{{selection[0].alarmAddInfo3}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row" *ngIf="type === 'active'">
      <span class="arm-summary-name" fxFlex="45">Acknowledged:</span>
      <span class="arm-summary-value" fxFlex><i class="fa fa-times not-acknowledged" [hidden]="selection[0].isAcknowledged"></i></span>
      <span class="arm-summary-value" fxFlex><i class="fa fa-check acknowledged" [hidden]="!selection[0].isAcknowledged"></i></span>
    </div>

  </div>
</div>
